import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  GetQuestionByIdUseCaseInterface,
  GetQuestionOptionByIdUseCaseInterface,
} from 'domain/usecases';

interface IQuestionOptionsState {
  questionOptions: GetQuestionByIdUseCaseInterface.Result['options'];
  selectedOption: GetQuestionOptionByIdUseCaseInterface.Result;
}

interface IPayloadQuestionOptions
  extends PayloadAction<GetQuestionByIdUseCaseInterface.Result['options']> {}

interface IPayloadSelectedQuestionOption
  extends PayloadAction<GetQuestionOptionByIdUseCaseInterface.Result> {}

const initialState: IQuestionOptionsState = {
  questionOptions: [],
  selectedOption: null,
};

export const QuestionOptionsSlice = createSlice({
  name: 'question-options-slice',
  initialState,
  reducers: {
    loadQuestionOptions: (state, action: IPayloadQuestionOptions) => {
      state.questionOptions = action.payload;
    },
    clearQuestionOptions: (state) => {
      state.questionOptions = [];
    },
    loadSelectedQuestionOption: (
      state,
      action: IPayloadSelectedQuestionOption,
    ) => {
      state.selectedOption = action.payload;
    },
    clearSelectedQuestionOption: (state) => {
      state.selectedOption = null;
    },
  },
});

export const {
  loadQuestionOptions,
  loadSelectedQuestionOption,
  clearQuestionOptions,
  clearSelectedQuestionOption,
} = QuestionOptionsSlice.actions;

export default QuestionOptionsSlice.reducer;
